import React, { useEffect, useState, Fragment, ReactElement } from "react"
import { RouteComponentProps, Link } from "@reach/router"
import Tile from "../../components/Experience/Section/Tile/Tile"
import {
  Banner,
  Section,
  Navigation,
  Spinner,
  Filtering,
  Modal,
} from "../../components"
// import { useGetExperiencesByCategory } from "../../Hooks"
// import { sendPageTrackingEvent } from "../../services"
import trustedInfo from "./trustedInfo"
import styles from "./Home.scss"
import mockedExperiences from "../../mockedExperiences"

function renderTiles(children: Experience[]) {
  const sections: ReactElement[] = []
  children.forEach(
    (
      {
        name,
        price,
        sessions,
        pics,
        categories,
        participantsQuotasInfo,
        isTest,
      }: Experience,
      i: number
    ) => {
      sections.push(
        <Tile
          key={`${name}-${i}`}
          isTest={isTest}
          index={i}
          title={name}
          categories={categories}
          minMaxParticipants={participantsQuotasInfo}
          location={sessions[0].location}
          picture={pics[0]}
          price={price}
        />
      )
    }
  )
  return <div id="experiences">{sections}</div>
}

function renderTrustedCompanies() {
  return (
    <div id="trusted">
      {trustedInfo.map(({ src, alt, link }) => (
        <a key={alt} href={link} target="_blank" rel="noopener noreferrer">
          <img src={src} alt={alt} />
        </a>
      ))}
    </div>
  )
}

function renderSection(experiences: Experience[], loading: boolean) {
  return (
    <Fragment>
      <Section title="LES EXPERIENCES">
        <div className={loading && styles.loadingContainer}>
          {loading ? <Spinner centered={false} /> : renderTiles(experiences)}
        </div>
      </Section>
      <Section title="ILS UTILISENT ALLEZ GO !">
        {renderTrustedCompanies()}
      </Section>
    </Fragment>
  )
}

const filterByPriceLowerThanBudget = (budget, experiences) =>
  budget ? experiences.filter(({ price }) => price <= +budget) : experiences

const filterByLocation = (location, experiences) =>
  location
    ? experiences.filter((exp) => exp.sessions[0].location.includes(location))
    : experiences

const filterByDate = (startDate, endDate, experiences) => {
  const formattedStartDate = new Date(startDate).toDateString()
  const formattedEndDate = new Date(endDate).toDateString()

  return !startDate && !endDate
    ? experiences
    : experiences.filter(
        ({ sessions }) =>
          formattedStartDate &&
          formattedEndDate &&
          formattedStartDate <= new Date(sessions[0].date).toDateString() &&
          formattedEndDate >= new Date(sessions[0].date).toDateString()
      )
}

const filterByCategories = (cats, experiences) =>
  cats.length
    ? experiences.filter(({ categories }) =>
        cats.some((category) => categories.includes(category))
      )
    : experiences

const filterByNumberOfPeople = (numberOfPeople, experiences) =>
  numberOfPeople
    ? experiences.filter(
        ({ participantsQuotasInfo }) =>
          participantsQuotasInfo.min <= numberOfPeople &&
          participantsQuotasInfo.max >= numberOfPeople
      )
    : experiences

const HomePage = ({}: RouteComponentProps) => {
  const [searchedLocation, setSearchedLocation] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(true)
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [budget, setBudget] = useState<string>("")
  const [numberOfPeople, setNumberOfPeople] = useState<number>()
  const [categories, setCategories] = useState<[string]>([])
  const [selectedCategories, setSelectedCategories] = useState<[string]>([])
  const [startDate, setStartDate] = useState<Date>()
  const [endDate, setEndDate] = useState<Date>()
  const [experiences, setExperiences] =
    useState<Experience[]>(mockedExperiences)

  function onSearch() {
    const filteredByBudget = filterByPriceLowerThanBudget(
      budget,
      mockedExperiences
    )
    const filteredByLocation = filterByLocation(
      searchedLocation,
      filteredByBudget
    )
    const filteredByCategories = filterByCategories(
      selectedCategories,
      filteredByLocation
    )
    const filteredByDate = filterByDate(
      startDate,
      endDate,
      filteredByCategories
    )
    const filteredByNumberOfPeople = filterByNumberOfPeople(
      numberOfPeople,
      filteredByDate
    )

    setExperiences(filteredByNumberOfPeople)
  }
  // sendPageTrackingEvent("Home")

  function handleSeletedCategoriesChange(category: string) {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(
        selectedCategories.filter((cat) => cat !== category)
      )
    } else {
      setSelectedCategories([...selectedCategories, category])
    }
  }

  const closeModal = () => setIsOpen(false)

  const renderModal = () =>
    isOpen ? <Modal closeModal={closeModal} type="info" /> : null

  useEffect(() => {
    if (categories.length <= 1) {
      const allCategories = []
      experiences.forEach((exp) => allCategories.push(...exp.categories))
      setCategories([...new Set(allCategories)])
      window.scrollTo(0, 0)
    }
  }, [experiences])

  return (
    <Fragment>
      {renderModal()}
      <Navigation animated={true} />
      <Banner
        categories={categories}
        searchedLocation={searchedLocation}
        budget={budget}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        numberOfPeople={numberOfPeople}
        selectedCategories={selectedCategories}
        setSelectedCategories={handleSeletedCategoriesChange}
        setSearchedLocation={setSearchedLocation}
        setNumberOfPeople={setNumberOfPeople}
        setBudget={setBudget}
        onSearch={onSearch}
      />
      <div id="content" className={[styles.container, styles.center].join(" ")}>
        <Filtering
          onSearch={onSearch}
          categories={categories}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          selectedCategories={selectedCategories}
          setSelectedCategories={handleSeletedCategoriesChange}
          setSearchedLocation={setSearchedLocation}
          setNumberOfPeople={setNumberOfPeople}
          setBudget={setBudget}
          budget={budget}
          numberOfPeople={numberOfPeople}
          searchedLocation={searchedLocation}
        />
        <div>{renderSection(experiences)}</div>
      </div>
    </Fragment>
  )
}

export default HomePage
